<template>
  <transition name="fade">
    <div class="dialog" v-if="show">
      <div class='dialog-box'>
        <h1 class='dialog-title'>Error</h1>
        <p class='dialog-text'>{{msg}}</p>
        <p class='actions'>
          <button @click="$emit('close')">OK</button>
        </p>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
    name: 'Error',
    props: {
        show:    Boolean,
        msg:     String
    }
}  
</script>

<style scoped>
</style>
